interface WebPageSchemaProps {
  url: string;
  name: string;
  description: string;
  datePublished?: string;
  dateModified?: string;
}

export default function WebPageSchema({
  url,
  name,
  description,
  datePublished,
  dateModified,
}: WebPageSchemaProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    url,
    name,
    description,
    ...(datePublished ? { datePublished } : {}),
    ...(dateModified ? { dateModified } : {}),
    publisher: {
      '@type': 'Organization',
      name: 'The Vertex',
      url: 'http://cg91.cn/',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}